import { render } from "./HomeworkList.vue?vue&type=template&id=5c9058da&scoped=true"
import script from "./HomeworkList.vue?vue&type=script&lang=js"
export * from "./HomeworkList.vue?vue&type=script&lang=js"

import "./HomeworkList.vue?vue&type=style&index=0&id=5c9058da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9058da"]])

export default __exports__